<template>
  <a-card :bordered="false">
    <SearchListPage
      :query-item-list="getQueryItemList()"
      :columns="getColumns()"
      :request-promise="getDataPromise"
      :query-params="queryParams"
    >
      <a-select
        slot="selectedTest"
        placeholder="请选择"
        option-filter-prop="children"
        style="width: 100%"
        :filter-option="filterOption"
        @change="onChangeEvent"
      >
        <a-select-option value="jack">
          Jack
        </a-select-option>
        <a-select-option value="lucy">
          Lucy
        </a-select-option>
        <a-select-option value="tom">
          Tom
        </a-select-option>
      </a-select>
    </SearchListPage>
  </a-card>
</template>

<script>
import SearchListPage from '@/customComponents/SearchListPage/SearchListPage'

export default {
  name: 'TestPageList',
  components: { SearchListPage },
  data() {
    return {
      queryParams: {
        selectedName: undefined
      },
      selectOptions: [
        {
          label: '哈哈哈',
          value: '1'
        },
        {
          label: '小儿王',
          value: '2'
        }
      ]
    }
  },
  mounted() {
    setTimeout(() => {
      const list = []
      for (let i = 0; i < 30; i++) {
        list.push({
          label: '小儿王' + (i + 1),
          value: i
        })
      }
      this.selectOptions = list
    }, 3000)
  },
  methods: {
    getDataPromise(parameter) {
      console.error('queryParams', this.queryParams)
      console.error('parameter', parameter)
      return this.getTestPromise(parameter)
    },
    getQueryItemList() {
      // {
      //   name:"",//查询字段名称
      //   keys:[],//查询字段
      //   slot:"",对应的插槽
      //   type:"input", //input ,输入框  select 选择框 time 选择时间 date date-picker选择日期（单个）  range range-picker多个日期
      // }
      return [
        {
          name: '下单日期',
          keys: ['orderDate'],
          type: 'date',
          format: 'YYYY-MM-DD HH:mm:ss'
        },
        {
          name: '日期范围',
          keys: ['startTime', 'endTime'],
          type: 'range',
          format: 'YYYY/MM/DD'
        },
        {
          name: '名称',
          keys: ['searchName'],
          type: 'input'
        },
        {
          name: '时间',
          keys: ['time'],
          type: 'time'
        },
        {
          name: '自定义选择',//不推荐使用外部选择器
          slot: 'selectedTest'
        },
        {
          name: '内置选择',//选择器，
          type: 'select',
          keys: ['innerSelectValue'],
          selectOptions: this.selectOptions//只支持{value, label}对象的列表
        }
      ]
    },
    getColumns() {
      return [
        {
          title: '服务名称',
          dataIndex: 'msg'
        },
        {
          title: '服务等级',
          dataIndex: 'proNum'
        },
        {
          title: '服务类别',
          dataIndex: 'groupStatusStr'
        },
        {
          title: '地址',
          dataIndex: 'address'
        },
        {
          title: '电话号码',
          dataIndex: 'phone'
        },
        {
          title: '状态',
          dataIndex: 's1'
        },
        {
          width: '146px',
          title: '新建时间',
          dataIndex: 'date'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '240px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    },
    getTestPromise(parameter) {
      return new Promise(resolve => {
        const msgList = [
          { msg: '消息1', date: '2018-12-12 18:58', id: 1 },
          { msg: '消息2', date: '2018-12-22 18:58', id: 2 },
          { msg: '消息3', date: '2018-12-22 18:58', id: 3 },
          { msg: '消息4', date: '2018-12-22 18:58', id: 4 },
          { msg: '消息5', date: '2018-12-22 18:58', id: 5 },
          { msg: '消息6', date: '2018-12-22 18:58', id: 6 },
          { msg: '消息7', date: '2018-12-22 18:58', id: 7 },
          { msg: '消息8', date: '2018-12-22 18:58', id: 8 },
          { msg: '消息9', date: '2018-12-22 18:58', id: 9 },
          { msg: '消息10', date: '2018-12-22 18:58', id: 10 }
        ]
        const result = {
          pageSize: parameter.pageSize,
          pageNo: parameter.pageNo,
          totalCount: 1000,
          pageCount: 100,
          totalPage: 100,
          data: msgList
        }
        resolve(result)
      })
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    onChangeEvent(value) {
      // console.error("=====value=========",value)
      this.$set(this, 'queryParams', { ...this.queryParams, selectedName: value })//通知内部更新
    }
  }

}
</script>
<style scoped>
</style>